<div class="page-body" *ngIf="loading">
  <app-spinner></app-spinner>
</div>

<div class="page-body" *ngIf="!loading">
  <div class="banner" *ngIf="backNavigationAllowed()">
    <img src="assets/icon/Arrow-Left.svg" alt="" class="back-button" (click)="reroute()"/>
    <span class="back-text" (click)="reroute()">Tillbaka</span>
  </div>

  <div class="contents-wrapper">
    <div class="contents-container">
      <h1 class="heading">Hej!</h1>
      <p class="info-text">
        I nästa steg får du koppla upp dig mot din bank och välja vilket konto du
        vill att betalningar ska dras ifrån.
      </p>

      <div class="button-container">
        <zaver-primary-button [text]="'Välj bank & kontonummer'" (click)="confirm()"></zaver-primary-button>
      </div>
    </div>
  </div>
</div>
